<div class="basicrow tabtopb f-black roboto-r f-reg" *ngIf="this.screen==2">
        <div class="basicr-line f-big">
            Formulario de Afiliaci&oacute;n
        </div>

        <div class="basicrow text-center">
            <div class="shortcont">
                <div class="basicrow m-top-i">
                    <div class="basicrow text-justify">
                        Ahora Claro te brinda el servicio de D&eacute;bito Directo en el que podr&aacute;s afiliar tu pago de renta mensual para que se ejecute de manera autom&aacute;tica, as&iacute; no tendr&aacute;s que preocuparte por recordar tu fecha de facturaci&oacute;n y que tu servicio sea suspendido.
                    </div>
                </div>

                <div class="basicrow m-top-i m-bott-ii">
                    <div class="basicrow roboto-b f-bmed m-bott-ii">
                        Afiliar a
                    </div>

                    <select (change)="this.cambiarTipoPago()" [(ngModel)]="this.tiposPago" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
                        <option *ngFor="let item of this.tiposPagos" [ngValue]="item.value">{{item.label}}</option>
                    </select>
                </div>

                <div class="basicrow m-top-i">
                    <div class="logline full"></div>
                </div>

                <div class="basicrow roboto-b f-bmed m-top-i">
                    Datos de la Cuenta
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Banco
                    </label>

                    <div class="basicrow">
                        <select class="sel-f" [(ngModel)]="this.bankCode"  style="background-image:url(/assets/images/selectabarrw.png)">
                            <option value="021502011">Banco Popular of Puerto Rico</option>
                            <option value="021502341">Banco Santander of Puerto Rico</option>
                            <option value="221571473">Firstbank, P.R.</option>
                            <option value="021502804">Scotiabank of Puerto Rico</option>
                            <option value="221571415">Oriental Bank</option>
                            <option value="221582284">COOP. MANATI</option>
                            <option value="021582785">COOP. ISABELA</option>
                            <option value="021583658">COOP.ENERGIA ELECTRICA</option>
                            <option value="021582727">COOP. SAGRADA FAMILIA</option>
                            <option value="021582853">COOP. LAS PIEDRAS</option>
                            <option value="221582226">COOP. CAMUY</option>
                            <option value="221581706">COOP. MOCA</option>
                            <option value="021583247">COOP. SABANENA</option>
                            <option value="221582459">COOP.LA PUERTORRIQUENA</option>
                            <option value="267089712">FIRST BANK US V.G.</option>
                            <option value="221581641">COOP. ARECIBO</option>
                            <option value="021582743">COOP. SAN JOSE</option>
                            <option value="021584217">COOP. LOS HERMANOS</option>
                            <option value="021582976">COOP. AGUADA</option>
                            <option value="021583373">COOP.BARRIO QUEBRADA</option>
                            <option value="021583593">COOP. VILLALBA</option>
                            <option value="021583137">COOP. ANASCO</option>
                            <option value="021583360">COOP. MAYAGUEZ</option>
                            <option value="221672851">FIRST BANK US V.I.</option>
                            <option value="221581751">COOP. VALENCIANO</option>
                            <option value="221581722">COOP. MAUNABO</option>
                            <option value="221582077">COOP. JAYUYA</option>
                            <option value="021583111">COOP. SAN BLAS</option>
                            <option value="021583140">COOP. NAGUABENA</option>
                            <option value="021582662">COOP. CAGUAS</option>
                            <option value="021583328">COOP. CAPARRA</option>
                            <option value="021583056">COOP. CIALES</option>
                            <option value="021583027">COOP. VEGA ALTA</option>
                            <option value="021582756">COOP. AGUAS BUENAS</option>
                            <option value="221581748">COOP. ORIENTAL</option>
                            <option value="221582310">COOP. CABO ROJO</option>
                            <option value="021582701">COOP. GURABO</option>
                            <option value="021583483">COOP. PARROCOOP</option>
                            <option value="221582174">COOP. YAUCO</option>
                            <option value="021502040">CITIBANK</option>
                            <option value="221582323">HATICOOP</option>
                    </select>
                    </div>
                </div>

                <div class="basicrow m-top-i m-bott-ii">
                    <label class="label-f">
                        &#42; N&uacute;mero de Cuenta
                    </label>

                    <div class="basicrow">
                        <input [appOnlyNumber] class="inp-f" maxlength="20" type="password" ng-pattern="/^\d+$/" [(ngModel)]="this.bankAccountNo" autocomplete="off">
                    </div>
                </div>

                <div class="basicrow m-top-i">
                    <div class="logline full"></div>
                </div>

                <div class="basicrow text-center m-top-i">
                    <a    class="btns def-i red pull-right vcenter red-full-b" (click)="this.debitAccount();">
                        <span class="tabcell">
                            Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>


                </div>
            </div>
        </div>
</div>
